import { useEffect } from 'react';
import AppRoutes from './routes/AppRoutes';
import ToastContainer from './components/ToastContainer';
import ErrorBoundary from './components/ErrorBoundary';
import { useUiStore } from './store/uiStore';
import { useAuthStore } from './store/authStore';
import { useI18n } from './i18n/I18nProvider';

export default function App() {
  const theme = useUiStore((s) => s.theme);
  const hydrateAuth = useAuthStore((s) => s.hydrate);
  const { language, isArabic } = useI18n();

  // Apply theme class to root
  useEffect(() => {
    const root = document.documentElement;
    if (theme === 'dark') {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
  }, [theme]);

  useEffect(() => {
    const root = document.documentElement;
    root.lang = language;
    root.dir = isArabic ? 'rtl' : 'ltr';
  }, [language, isArabic]);

  // Hydrate auth from cookies on mount
  useEffect(() => {
    hydrateAuth();
  }, [hydrateAuth]);

  return (
    <ErrorBoundary>
      <AppRoutes />
      <ToastContainer />
    </ErrorBoundary>
  );
}
